module.exports = __webpack_public_path__ + "0f4f6f69f125c3845d0a54e9ca6d94b8.pdf";